import React from 'react';
import { Phone, Mail, MessageCircle, MapPin, Clock } from 'lucide-react';

export default function ContactConfigSection({ config, onChange }) {
  const handleChange = (field, value) => {
    onChange({
      ...config,
      [field]: value
    });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-2 mb-4">
        <Phone className="text-green-600" size={24} />
        <h2 className="text-xl font-semibold text-gray-900">Informations de Contact</h2>
      </div>
      
      <p className="text-gray-600 text-sm mb-6">
        Configurez les coordonnées que Fatou partagera avec les clients.
      </p>

      <div className="space-y-4">
        <div>
          <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
            <Phone size={16} className="mr-2" />
            Téléphone Principal
          </label>
          <input
            type="tel"
            value={config?.phone || ''}
            onChange={(e) => handleChange('phone', e?.target?.value)}
            placeholder="+33 X XX XX XX XX"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>

        <div>
          <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
            <MessageCircle size={16} className="mr-2" />
            WhatsApp
          </label>
          <input
            type="tel"
            value={config?.whatsapp || ''}
            onChange={(e) => handleChange('whatsapp', e?.target?.value)}
            placeholder="+33 X XX XX XX XX"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>

        <div>
          <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
            <Mail size={16} className="mr-2" />
            Email
          </label>
          <input
            type="email"
            value={config?.email || ''}
            onChange={(e) => handleChange('email', e?.target?.value)}
            placeholder="contact@adtexpress.cloud"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>

        <div>
          <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
            <MapPin size={16} className="mr-2" />
            Adresse
          </label>
          <textarea
            value={config?.address || ''}
            onChange={(e) => handleChange('address', e?.target?.value)}
            placeholder="Adresse complète de l'entreprise"
            rows={3}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>

        <div>
          <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
            <Clock size={16} className="mr-2" />
            Horaires d'Ouverture
          </label>
          <input
            type="text"
            value={config?.hours || ''}
            onChange={(e) => handleChange('hours', e?.target?.value)}
            placeholder="Lun-Ven: 9h-18h"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>
      </div>

      <div className="bg-green-50 border border-green-200 rounded-lg p-4 mt-6">
        <p className="text-sm text-green-800">
          <strong>Conseil:</strong> Assurez-vous que ces informations sont à jour. Fatou les utilisera pour diriger les clients vers les bons canaux de communication.
        </p>
      </div>
    </div>
  );
}